import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";

import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class TipsService {
  baseURL = environment.baseUrl + 'tips';

  constructor(
    private http: HttpClient
  ) {
  }

  getAllTips(eventId: any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/event/${eventId}`);
  }

  saveTip(eventId: any, newAgenda: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/save/event/${eventId}`, newAgenda);
  }

  deleteTips(eventId: any, tipId: any): Observable<any> {
    const params = new HttpParams()
      .set('tipId', tipId);
    return this.http.delete<any>(`${this.baseURL}/event/${eventId}`, {params})
  }

  updateOrder(eventId: any, tipsList: any): Observable<any> {
    return this.http.patch<any>(`${this.baseURL}/update/event/${eventId}`, tipsList)
  }

  saveTipTitle(eventId: any, title: any): Observable<any> {
    const params = new HttpParams()
      .set('title', title);
    return this.http.post<any>(`${this.baseURL}/saveTipTitle/event/${eventId}`, {}, {params});
  }
}
